import { X } from 'lucide-react';
import { cn } from '../../lib/utils';

const toneClasses = {
  document: 'border-emerald-200/80 bg-emerald-50 text-emerald-900',
  link: 'border-sky-200/80 bg-sky-50 text-sky-900',
  note: 'border-violet-200/80 bg-violet-50 text-violet-900',
  tool: 'border-amber-200/80 bg-amber-50 text-amber-900',
  subject: 'border-primary/20 bg-primary/5 text-primary',
  neutral: 'border-border/80 bg-background/90 text-foreground',
};

export default function LectureAiChip({
  icon: Icon,
  label,
  meta,
  tone = 'neutral',
  active = false,
  onClick,
  onRemove,
  disabled = false,
  className,
}) {
  const Comp = onClick ? 'button' : 'div';

  return (
    <Comp
      type={onClick ? 'button' : undefined}
      onClick={onClick}
      disabled={disabled}
      className={cn(
        'group inline-flex items-center gap-2 rounded-full border px-3 py-2 text-xs font-medium shadow-sm transition-[transform,background-color,border-color,color] duration-150 ease-out motion-reduce:transition-none',
        'active:scale-[0.97] disabled:pointer-events-none disabled:opacity-60',
        toneClasses[tone] || toneClasses.neutral,
        active && 'ring-2 ring-primary/15',
        onClick && 'hover:-translate-y-[1px]',
        className,
      )}
    >
      {Icon ? <Icon className="h-3.5 w-3.5 shrink-0 opacity-80" aria-hidden /> : null}
      <span className="truncate">{label}</span>
      {meta ? <span className="truncate text-[11px] opacity-70">{meta}</span> : null}
      {onRemove ? (
        <span
          role="button"
          tabIndex={0}
          onClick={(event) => {
            event.stopPropagation();
            onRemove();
          }}
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              event.stopPropagation();
              onRemove();
            }
          }}
          className="ml-0.5 inline-flex h-4 w-4 items-center justify-center rounded-full opacity-60 transition-opacity group-hover:opacity-100"
          aria-label={`Remove ${label}`}
        >
          <X className="h-3 w-3" />
        </span>
      ) : null}
    </Comp>
  );
}
